export const simpleInterest = (principle, rate, time) => {
    return (principle * rate * time)
}

export const amountSI = (principle, rate, time) => {
    return principle + simpleInterest(principle, rate, time)
}

export const amountCompound = (principle, rate, time, number_of_time_per_time = 1) => {
    if (time < 1) {
        return amountSI(principle, rate, time)
    } else {
        return principle * ((1 + rate/number_of_time_per_time) ** (number_of_time_per_time * time))
    }
}

export const compoundInterest = (principle, rate, time, number_of_time_per_time = 1) => {
    return amountCompound(principle, rate, time, number_of_time_per_time) - principle
}

export const getGSTPercentageTotal = (products) => {
    let GST_Percentage_total = {
        GST_0 : 0,
        GST_3 : 0,
        GST_5 : 0,
        GST_12 : 0,
        GST_18 : 0,
        GST_28 : 0 
    }
    products.map((product)=>{
        switch(product.taxableGST_rate) {
            case 0 : {
                GST_Percentage_total["GST_0"] += Number.parseFloat(product["GSTValue"]);
                break;
            }
            case 3 : {
                GST_Percentage_total["GST_3"] += Number.parseFloat(product["GSTValue"]);
                break;
            }
            case 5 : {
                GST_Percentage_total["GST_5"] += Number.parseFloat(product["GSTValue"]);
                break;
            }
            case 12 : {
                GST_Percentage_total["GST_12"] += Number.parseFloat(product["GSTValue"]);
                break;
            }
            case 18 : {
                GST_Percentage_total["GST_18"] += Number.parseFloat(product["GSTValue"]);
                break;
            }
            case 28 : {
                GST_Percentage_total["GST_28"] += Number.parseFloat(product["GSTValue"]);
                break;
            }
        }
    })
    return GST_Percentage_total;
}

export default {
    getGSTPercentageTotal,
    simpleInterest,
    amountSI,
    compoundInterest,
    amountCompound
}


// WEBPACK FOOTER //
// ./src/utils/index.js